import React, { useState, useRef } from "react"
import PropTypes from "prop-types"
import Button from "../Button/Button"
import Image from "../Image/Image"
import useIntersectionObserver from "../../../hooks/useIntersection"
import { imageConstants } from "../../../constants/image.constants"
import useImage from "../../../hooks/useImage"
import * as styles from "./InlineView-tw-styles"
import AblePlayer from "./AblePlayer"
const InlineView = props => {
  const {
    poster,
    videoLink,
    isIframe,
    title,
    videoId,
    image,
    isImageToggle,
    variant,
    isButtonBlack = false,
    isCareerPage,
  } = props
  const { altText, foregroundImg } = useImage(poster)
  const [showPlay, setShowPlay] = useState(true)
  const [isPlayVideo, setVideoState] = useState(false)
  const videoRef = useRef(null)

  const style = styles[variant] || styles.defaultStyle
  // if iframe is in viewport, then render
  const ref = useRef(null)
  const entry = useIntersectionObserver(ref, {})
  const isVisible = !!entry?.isIntersecting
  const togglePlayPause = event => {
    event.preventDefault()
    const video = videoRef.current
    video.paused ? video.play() : video.pause()
    setShowPlay(video.paused)
  }

  const playPauseVideo = () => {
    setVideoState(!isPlayVideo)
  }

  const showPlayCls = () => {
    if (!isPlayVideo) {
      return style?.showImg
    } else {
      return style?.hideImg
    }
  }
  const showVideoCls = () => {
    if (isPlayVideo) {
      return style?.videoFrame
    } else {
      return style?.videoFrameHide
    }
  }
  function renderHomePageVideo() {
    return (
      <div className={style?.videoWrapper}>
        {isImageToggle && (
          <Button className={showPlayCls()} onClick={playPauseVideo}>
            <Image
              contentfulImage={foregroundImg}
              className={`${style?.playBtnImg} event_video_play`}
              alt={altText}
            />
            {isButtonBlack ? (
              <Image
                contentfulImage={imageConstants.playBtnBlack}
                className={style?.playButton}
              />
            ) : (
              <Image
                contentfulImage={imageConstants.playBtnWhite}
                className={style?.playButton}
              />
            )}
          </Button>
        )}
        <div
          className={isImageToggle ? showVideoCls() : style?.videoframe}
          ref={ref}
        >
          {isVisible && (
            <>
              {isCareerPage ? (
                <iframe
                  src={`${videoLink}&playlist=${videoId}&autoplay=1&mute=1&loop=1&controls=0&showinfo=0&modestbranding=1&fs=0&autohide=1&rel=0&version=3`}
                  frameBorder="0"
                  width={"100%"}
                  height={"100%"}
                  allowFullScreen
                  title={title || "YouTube video player"}
                  allow={"autoplay"}
                  id={"videoId"}
                  className={[style?.videoItem, "event_video_play"].join(" ")}
                  data-action-detail={`${videoLink}`}
                  csp="*.youtube.com"
                />
              ) : (
                <iframe
                  data-src={`${videoLink}`}
                  frameBorder="0"
                  width={isImageToggle ? "700" : "100%"}
                  height={isImageToggle ? "400" : "100%"}
                  allowFullScreen
                  title={title || "YouTube video player"}
                  allow={"autoplay"}
                  id={isImageToggle ? videoId : "youtubeVideo"}
                  className={[
                    style?.videoItem,
                    "event_video_play",
                    "optanon-category-C0004",
                  ].join(" ")}
                  data-action-detail={`${videoLink}`}
                  csp="*.youtube.com"
                />
              )}
            </>
          )}
        </div>
      </div>
    )
  }

  const renderIframe = () => {
    return <div className={style?.videoCntr}>{renderHomePageVideo()}</div>
  }

  const getPlayClass = () => {
    if (showPlay) {
      return "absolute playbtn"
    }
    return "hidden"
  }

  return (
    <div>
      {isIframe ? (
        <>
          {isCareerPage ? (
            renderIframe()
          ) : (
            <>
              <AblePlayer {...props}></AblePlayer>
            </>
          )}
        </>
      ) : (
        <Button
          className={style?.btnImg}
          onClick={togglePlayPause}
          gaEventClass={"event_video_play"}
        >
          <video
            ref={videoRef}
            poster={poster}
            controls
            width={"100%"}
            height={"100%"}
            className={"video-player"}
          >
            <source src={videoLink} type="video/mp4" />
            {"Your browser does not support the video tag."}
          </video>

          <Image contentfulImage={image} className={getPlayClass()} />
        </Button>
      )}
    </div>
  )
}

InlineView.propTypes = {
  poster: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isIframe: PropTypes.bool,
  title: PropTypes.string,
  youtubeVideoId: PropTypes.string,
  videoId: PropTypes.string,
  style: PropTypes.object,
  isImageToggle: PropTypes.bool,
  videoLink: PropTypes.string,
  image: PropTypes.object,
  variant: PropTypes.string,
  isButtonBlack: PropTypes.bool,
  isCareerPage: PropTypes.bool,
}

export default InlineView
